import React, { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/LocaleContext';

// Full-screen "排单" overlay shown from CTA click until the order sheet opens.
// 玩法来自 uiverse 地图卡片：等待期间随机城市自动弹路牌，点击城市也能弹。
// 路牌文案按盘口语言（越/英/韩/日）随机取，不含中文。
const MAP_SPOTS = [
  { x: 8, y: 67 },
  { x: 32, y: 32 },
  { x: 58, y: 83 },
  { x: 65, y: 22 },
  { x: 85, y: 58 },
  { x: 90, y: 38 },
];

// 盘口市场周边城市，标签语言覆盖 vi/en/ko/ja（除掉中文）。
const CITY_SIGNS = [
  { icon: '🏖️', text: 'Đà Nẵng' },
  { icon: '🌆', text: 'Hà Nội' },
  { icon: '🗼', text: '東京' },
  { icon: '🏯', text: '大阪' },
  { icon: '🎡', text: '서울' },
  { icon: '🌃', text: 'Seoul' },
  { icon: '🛕', text: 'Bangkok' },
  { icon: '🌉', text: 'Singapore' },
  { icon: '🌇', text: 'Manila' },
  { icon: '🏝️', text: 'Jakarta' },
];

const pick = (list) => list[Math.floor(Math.random() * list.length)];

const QueueOverlay = () => {
  const { t } = useTranslation();
  const [pop, setPop] = useState(null);

  useEffect(() => {
    let alive = true;
    const show = () => {
      if (!alive) return;
      setPop((prev) => ({
        spot: pick(MAP_SPOTS),
        sign: prev ? pick(CITY_SIGNS.filter((c) => c.text !== prev.sign.text)) : pick(CITY_SIGNS),
        anim: Math.random() < 0.5 ? 'anim-grow' : 'anim-slidein',
        key: Date.now(),
      }));
    };
    show();
    const timer = setInterval(show, 2600);
    return () => { alive = false; clearInterval(timer); };
  }, []);

  const tapSpot = (spot) => {
    setPop((prev) => ({
      spot,
      sign: prev ? pick(CITY_SIGNS.filter((c) => c.text !== prev.sign.text)) : pick(CITY_SIGNS),
      anim: Math.random() < 0.5 ? 'anim-grow' : 'anim-slidein',
      key: Date.now(),
    }));
  };

  return (
    <div className="fixed inset-0 z-[70] flex flex-col items-center justify-center gap-8 bg-black/80 backdrop-blur-sm animate-fade-in">
      <div className="text-center">
        <p className="gpt-shimmer-text text-[16px] font-extrabold">{t('ordQueueing')}</p>
        <p className="mt-2 text-[12px] text-white/55">{t('ordQueueHint')}</p>
      </div>

      <div className="queue-map">
        <svg viewBox="0 0 500 500" aria-hidden="true">
          <rect fill="#F3F6FC" width="500" height="500" />
          <path fill="#DCE9FB" d="M0,367.82c5.83-4.39,14.42-10.16,25.59-15.34,4.52-2.09,43.19-19.51,79.55-11.93,36.1,7.52,35.75,32.55,78.41,60.23,46.34,30.06,109.47,41.21,123.32,22.1,11.95-16.49-22.61-41.92-13.66-84.6,4.85-23.1,22.33-50.71,47.73-58.52,42.42-13.05,78.83,39.45,102.84,23.86,15.81-10.26.01-32.87,22.73-74.43,5.8-10.62,11.65-21.15,11.93-36.93.28-15.69-5.63-26.64-7.95-32.39-6.66-16.45-6.21-45.15,28.84-98.55.23,146.23.46,292.46.69,438.69H0v-132.18Z" />
        </svg>
        {MAP_SPOTS.map((spot, i) => {
          const active = pop && pop.spot === spot;
          return (
            <div
              key={i}
              className={`queue-city${active ? ' pop' : ''}`}
              style={{ '--x': spot.x, '--y': spot.y }}
              onClick={() => tapSpot(spot)}
            >
              {active && (
                <div className="queue-city__label">
                  <span
                    key={pop.key}
                    data-icon={pop.sign.icon}
                    className={`queue-city__sign anim ${pop.anim}`}
                  >
                    {pop.sign.text}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QueueOverlay;
